import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ImSpinner8 } from "react-icons/im";
import { useSelector } from "react-redux";

const LeadCompainModal = ({ isOpen, onClose, onConfirm, workers }) => {
  const [campaignName, setCampaignName] = useState("");
  const [Message, setInitialMessage] = useState("");
  const [selectedWorker, setSelectedWorker] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { usersDetails } = useSelector((state) => state.user);
  const { team_lead } = useSelector((state) => state.team_lead);

  const activeWorkers = workers.filter((worker) => worker.status === "Active");

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (campaignName && selectedWorker && Message) {
      setLoading(true);
      await onConfirm({ campaignName, workerId: selectedWorker, Message });
      setCampaignName("");
      setInitialMessage("");
      setLoading(false);
      onClose();
    } else {
      toast.error(
        "Campaign name, initial message, and chatbot selection are required"
      );
    }
  };


  if (!isOpen) return null;

  return (
    <form onSubmit={handleSubmit}>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-700 bg-opacity-50">
        <div className="bg-white p-6 rounded shadow-md w-96">
          <h2 className="text-xl font-semibold mb-4">Campaign Info</h2>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Campaign Name
            </label>
            <input
              type="text"
              value={campaignName}
              onChange={(e) => setCampaignName(e.target.value)}
              className="mt-1 border border-gray-300 block py-2 px-2 w-full rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Initial Message
            </label>
            <input
              type="text"
              value={Message}
              onChange={(e) => setInitialMessage(e.target.value)}
              className="mt-1 border border-gray-300 block py-2 px-2 w-full rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Select Chatbot
            </label>
            {activeWorkers.length > 0 ? (
              <select
                value={selectedWorker}
                onChange={(e) => setSelectedWorker(e.target.value)}
                className="mt-1 border border-gray-300 block py-2 px-2 w-full rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                required
              >
                <option value="" disabled>
                  Select a Chatbot
                </option>
                {activeWorkers.map((worker) => (
                  <option key={worker.id} value={worker.id}>
                    {worker.name}
                  </option>
                ))}
              </select>
            ) : (
              <p className="text-red-500 text-[14px] text-center">
                Please Make At Least 1 Chatbot And Also Switch it to Active
              </p>
            )}
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white w-[25%] px-4 py-2 rounded mr-2"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 w-[25%] rounded flex items-center justify-center"
              disabled={loading || activeWorkers.length === 0}
            >
              {loading ? (
                <ImSpinner8 className="spinning-icon animate-spin" />
              ) : (
                "Confirm"
              )}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default LeadCompainModal;
